// export const apiAddress = 'https://somnium.space/identity/api'
export const apiAddress = 'https://somniumspace.org/identity/api'

// export const webAddress = 'https://somniumspace.store'
export const webAddress = 'https://somniumspace.com'
